export default "__VITE_ASSET__834d1c4e__"